/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export interface IDealerwareLoading {
        show(message: string) : any;
    }

    export class Loading implements IDealerwareLoading {
        public static $inject: string[] = [ '$mdPanel' ];

        constructor(public $mdPanel: any) {}

        public show(message: string) : any {
            var loader = this.$mdPanel.create({
                attachTo: angular.element(document.body),
                controller: ($scope: any) => {
                    $scope.message = message;
                },
                position: this.$mdPanel.newPanelPosition().absolute().center(),
                animation: this.$mdPanel.newPanelAnimation().duration(200).withAnimation(this.$mdPanel.animation.FADE),
                templateUrl: '/services/loading/loading.html',
                panelClass: 'loading-panel',
                disableParentScroll: true,
				hasBackdrop: true,
				trapFocus: true,
                clickOutsideToClose: false,
                escapeToClose: true,
                focusOnOpen: true
            });

            loader.open();

            return loader;
        }
    }

    getDealerwareWebServicesModule().service("$dealerwareLoading", Loading);
}
